// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#488019"};